<template>
  <div class="client-quotation">
    <!-- <b-tabs pills card>
                <b-tab title="Booking Request" active
                    ><b-card-text> -->
    <SelectType v-model="request_quotation.service_type" />
    <!-- v-if="request_quotation.service_type" -->
    <!-- :is="checkServiceReturnComponent(request_quotation.service_type)" -->
    <component
      :is="checkServiceReturnComponent(6)"
      :value.sync="request_quotation"
      ref="VanTruckKH"
      :readonly="readonly"
    />
    <div class="text-right">
      <a
        v-if="!readonly"
        @click="sendRequestQuotation"
        class="btn round btn-success pl-4 pr-4 mr-1"
      >
        <feather-icon icon="SendIcon" /> New Booking
      </a>
    </div>
    <!-- </b-card-text
                ></b-tab>

                <b-tab disabled title="Quote"
                    ><b-card-text>Tab contents 2</b-card-text></b-tab
                >
            </b-tabs> -->
  </div>
</template>

<script>
import SelectType from "./components/SelectType.vue";
import { $ctx } from "@themeConfig";
import moment from "moment";
import VanTruckKH from "./VanTruckKH.vue";
import { ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
export default {
  props: {
    view_RequestQuotation: { default: null },
    readonly: false,
    isCopy: {
      default: false,
    },
  },
  components: {
    SelectType,
    VanTruckKH,
    ValidationObserver,
    ToastificationContent,
  },
  computed: {
    mySelection() {
      this.request_quotation.service_type = this.serviceType;
      this.checkServiceReturnComponent(this.serviceType);
      return this.serviceType;
    },
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
    ]),
  },
  watch: {},
  data() {
    return {
      modalSchedule: false,
      buttonKey: 1,
      moment,
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      vm: this,
      userData: JSON.parse(localStorage.getItem("userData")),

      locationsByUser: [],

      request_quotation: {
        quotation: null,
        shippingType: null,
        eta: null,
        etd: null,
        customs_other_service_type: null,
        has_container_trucking: null,
        isHideShows: false,
        isHideShowPks: false,
        other_delivery_location: null,
        pickup_location: null,
        delivery_location: null,
        other_pickup_region: null,
        other_delivery_region: null,
        pickup_region: null,
        delivery_region: null,
        company_id: null,
        customer_id: null,
        service_type: 6,
        pod_port: null,
        pol_port: null,
        incoterms: null,
        cont_type: null,
        goods_type: null,
        package_type: null,
        transport_type: null,
        deport: null,
        business_type: null,
        so_luong: null,
        trong_luong: null,
        mo_ta: null,
        volume: null,
        from_date: null,
        to_date: null,
        other_service: null,
        notes: null,
        so_khoi: null,
        so_kien: null,
        shipping_line: null,
        place_of_stuffing: null,
        totalChargeWeight: null,
        size_: {
          length_: null,
          width_: null,
          height_: null,
        },
        cargo_ready: moment().format("DD/MM/YY HH:mm"),
        customs_addr: null,
        hs_code: null,
        isPickUpInput: false,
        isAddressInput: false,
        valuePickupInput: null,
        valueAddressInput: null,
        pickUpContact: {
          name: null,
          phone: null,
        },
        deliveryContact: {
          name: null,
          phone: null,
        },
        pickUpDateTime: null,
        pickUpDate: null,
        pickUpTime: null,
        deliveryDateTime: null,
        deliveryDate: null,
        deliveryTime: null,
        cargo_booking: null,
        carrier: null,
        cargo_closing_dateTime: null,
        cargo_closing_date: null,
        cargo_closing_time: null,
        valueVan: [
          {
            id: 1,
            hasDelete: false,
            truck_type: null,
            quantity: null,
            commodity_type: null,
            VanLine: [
              {
                id: 2,
                hasDelete: false,

                commodity: null,
                total_gross_weight: null,
                total_package: null,
                total_volume: null,
                dimension: {
                  length: null,
                  width: null,
                  height: null,
                },
              },
            ],
          },
        ],
        cargo_details_container_truck: [
          {
            id: 2,
            hasDelete: false,
            container_type: null,
            quantity: null,
            total_gross_weight: null,
          },
        ],
        additional_custom: false,
        additional_custom_input: null,
        has_other_custom: false,
        place_of_custom: null,
        HS_code_truck: null,
        customs_type: null,
        notes_truck: null,
      },
      customer_list_options: null,

      volumes: [
        { id: 1, text: "1-10" },
        { id: 2, text: "10-30" },
        { id: 3, text: "30-50" },
        { id: 4, text: "50-100" },
        { id: 5, text: ">100" },
      ],
      currencies: [
        { id: "VND", text: "VNĐ" },
        { id: "USD", text: "USD" },
      ],
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        addRemoveLinks: !this.readonly,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
        clickable: !this.readonly,
      },
      customer_list: null,
      useName: null,
      costs: [],

      countRq: 0,
    };
  },
  created() {
    if (this.view_RequestQuotation != null) {
      // this.request_quotation.service_type

      this.request_quotation = this.view_RequestQuotation;
      this.isHideShow =
        this.view_RequestQuotation.other_pickup_location != null ? true : false;

      this.isHideShowPk =
        this.view_RequestQuotation.other_delivery_location != null
          ? true
          : false;

      this.isHideShow =
        this.view_RequestQuotation.other_pickup_region != null ? true : false;

      this.isHideShowPk =
        this.view_RequestQuotation.other_delivery_region != null ? true : false;
      !this.request_quotation.size_
        ? (this.request_quotation = {
            ...this.request_quotation,
            size_: {
              length_: null,
              width_: null,
              height_: null,
            },
          })
        : "";
    }
  },
  mounted() {
    this.request_quotation.company_id = this.companyItems.find(
      (e) => e.name == this.userData.companyName
    )?.code;

    this.request_quotation.customer_id = this.userData.username;
  },
  methods: {
    async sendRequestQuotation() {
      var validate =
        await this.$refs.VanTruckKH.$refs.Routing.$refs.validateRouting
          .validate()
          .then((success) => {
            return success;
          });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check Routing Details field",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      validate =
        await this.$refs.VanTruckKH.$refs.Cargo.$refs.validateCargoTruck
          .validate()
          .then((success) => {
            return success;
          });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check Cargo Details field",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      //   validate =
      //     await this.$refs.VanTruckKH.$refs.Billing.$refs.validateBilling
      //       .validate()
      //       .then((success) => {
      //         return success;
      //       });
      //   if (!validate) {

      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: "Please check Billing Information field",
      //         icon: "AlertTriangleIcon",
      //         variant: "warning",
      //       },
      //     });
      //     return;
      //   }
      // this.request_quotation.files = [];
      // let route = this.$router;

      // for (
      //   var i = 0;
      //   i <
      //   this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()
      //     .length;
      //   i++
      // ) {
      //   var file = JSON.parse(
      //     this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
      //       i
      //     ].xhr.response
      //   ).result;
      //   file.size =
      //     this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
      //       i
      //     ].size;
      //   file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
      //   file.uuid =
      //     this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
      //       i
      //     ].upload.uuid;

      //   file.fullName = this.userData.fullName;
      //   file.username = this.userData.username;
      //   this.request_quotation.files.push(file);
      // }
      let service = "RequestBooking";
      this.$loading.show();
      if (this.view_RequestQuotation != null && this.isCopy == false) {
        useJwt
          .put("wr1?objectType=" + service, this.request_quotation)
          .then((response) => {
            this.$emit("ok-clicked");
            if (this.step == null || this.step == "created-quotation") {
              this.$emit("sendRequestQuotationEvent");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("bookingSaleSuccess"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            } else {
              this.$emit("sendRequestBookingEvent");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("bookingSaleSuccess"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      } else {
        useJwt
          .post("wr1?objectType=" + service, this.request_quotation)
          .then((response) => {
            // khách hàng tạo mới booking tạo xong thì upfile
            if (response.data.meta.booking_id) {
              var files = [];
              for (
                var i = 0;
                i <
                this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()
                  .length;
                i++
              ) {
                var file = JSON.parse(
                  this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                    i
                  ].xhr.response
                ).result;
                file.size =
                  this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                    i
                  ].size;
                file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
                file.uuid =
                  this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                    i
                  ].upload.uuid;
                file.username = this.userData.username;
                file.fullName = this.userData.fullName;

                file.uuid =
                  this.$refs.VanTruckKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                    i
                  ].upload.uuid;
                file.bookingId = response.data.meta.booking_id;
                file.isRequestFile = "1";
                files.push(file);

                this.$store.dispatch("attachFile/upFile", file);
              }
            }
            this.$emit("ok-clicked");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleSuccess"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            if (this.step == null || this.step == "created-quotation") {
              this.$emit("sendRequestQuotationEvent");
            } else {
              this.$emit("sendRequestBookingEvent");
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      }
    },

    checkServiceReturnComponent(type) {
      if (type && type == 6) {
        return "VanTruckKH";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/customs/request-quotation.scss";
@import "@core/scss/customs/inputV2.scss";
</style>
